<template>
  <div class="container-fluid">
    <div class="center">
      <span class="xz-title">{{ location.name }}</span><br/>
      <span>Org.nr. {{ location.vatNumber }} MVA</span>
      <hr class="horizontal-dashed"/>
      <span class="xz-title">Z-rapport (Dagsoppgjør)</span>
    </div>
    <span>Dato: {{ zReportDateTime }}</span><br/>
    <span v-if="terminal.systemIdNr">ID-nr.: {{ terminal.systemIdNr }} <br/> </span>

    <span v-if="terminal.terminalType == 'POS'"> POS-ID: {{ terminal.terminalId }}</span>
    <span v-else-if="terminal.terminalId == 'WEBSHOP'"> Kassepunkt: {{ terminal.terminalId }}</span>
    <span v-else> KIOSK-ID: {{ terminal.terminalId }}</span>

    <br/>
    <span>Nr.: {{ zReport.nr }}</span><br/>
    <hr class="horizontal-dashed"/>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    location: Object,
    company: Object,
    terminal: Object,
    zReport: Object
  },
  computed: {
    zReportDateTime() {
      return (moment(this.zReport.createdTime)).format('DD.MM.YYYY HH:mm');
    }
  },
}
</script>
